<div class="group">
  <div class="group__title">{{ 'menu.organizationDocuments' | translate }}</div>

  <div class="group__options">
    <a routerLink="/documentos/grupo" class="group__option">
      <div class="group__option-icon"><i class="fal fa-users-class"></i></div>
      <div class="group__option-name">{{ 'menu.wholeGroup' | translate }}</div>
    </a>

    <a routerLink="/documentos/organizacao" class="group__option">
      <div class="group__option-icon"><i class="fal fa-users"></i></div>
      <div class="group__option-name">{{ 'menu.wholeOrganization' | translate }}</div>
    </a>
  </div>
</div>
